var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.989,
    height: 15,
    viewBox: "0 0 14.989 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "like",
    transform: "translate(-0.194 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(0.194 6.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M.638,224.948a.444.444,0,0,0-.444.444v6.517a.444.444,0,0,0,.444.444H3.311v-7.4Z",
    transform: "translate(-0.194 -224.948)",
    fill: "#c1c1c1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(4.199 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M147.87,9.041a1.548,1.548,0,0,0-.754-1.328,1.546,1.546,0,0,0-1.273-2.425h-3.265c.1-.454.237-1.134.332-1.846.248-1.854.079-2.882-.533-3.236a1.337,1.337,0,0,0-1.158-.126,1.523,1.523,0,0,0-.881,1.021l-.858,2.247a8.382,8.382,0,0,1-2.594,2.826v8.018a14.344,14.344,0,0,0,4.76.809H145.2a1.546,1.546,0,0,0,1.315-2.361,1.546,1.546,0,0,0,.6-2.27A1.548,1.548,0,0,0,147.87,9.041Z",
    transform: "translate(-136.886 0)",
    fill: "#c1c1c1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyLike);
export default __webpack_public_path__ + "static/media/greyLike.48ed2546b5f4a80be031e5cb003b0aca.svg";
export { ForwardRef as ReactComponent };